import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=0be5be9c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=0be5be9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be5be9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0be5be9c')) {
      api.createRecord('0be5be9c', component.options)
    } else {
      api.reload('0be5be9c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=0be5be9c&scoped=true&", function () {
      api.rerender('0be5be9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2r1wU4hEhwa13/JS/comp/PopupBox.vue"
export default component.exports